<template>
<svg version="1.1" class="or-role-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 25 25" width="24px" style="enable-background:new 0 0 25 25;" xml:space="preserve">
	 <path fill="currentColor" d="M16.33,8.13c-2.07,0-3.82,1.43-4.29,3.36h-6.96v2.1h6.96c.47,1.94,2.22,3.37,4.29,3.37,2.43,0,4.42-1.98,4.42-4.42s-1.99-4.41-4.42-4.41ZM16.33,14.86c-1.28,0-2.32-1.04-2.32-2.32s1.04-2.31,2.32-2.31,2.32,1.03,2.32,2.31-1.04,2.32-2.32,2.32Z"/>
 </svg>
</template>
